import React from 'react'

import Reflux from 'reflux-react-16'
import _ from 'lodash'

import Guid from '../../../../../utils/guid.js'

import {Alert, Button, H3, P, ListItem, Panel, Row, Card, H5, Popup, SortableList} from '../../../../components/UI/index.js'
import PriceTableModal from '../../../../components/resellers/PriceTableModal.js'
import EditProductModal from '../../../../components/settings/products/EditProductModal.js'
import CustomerStore from '../../../../stores/CustomerStore.js'
import naturalSortBy from 'src/utils/naturalSortBy.js'
import Languages from '@utils/Languages.js'
import guid from '../../../../../utils/guid.js'
import {formSpacing} from '../../../../components/UI/forms/index.js'

class OrderPrices extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            name: '',
            nameValidation: null,
            error: ''
        }
    }

    onChangeChecked(path, event) {
        const reseller = {...this.props.reseller}

        _.set(reseller.settings, path, event.target.checked)

        this.props.onChange(reseller, path)
    }

    onClickNewPriceTable() {
        this.orderPriceTableModal.open()
    }

    onUpdatePriceTable(priceTable) {
        const reseller = {...this.props.reseller}

        const index = reseller.settings.orders.prices.findIndex((pt) => pt.id === priceTable.id)

        if (typeof index === 'number' && index !== -1) {
            reseller.settings.orders.prices[index] = priceTable
        } else {
            reseller.settings.orders.prices = reseller.settings.orders.prices || []
            reseller.settings.orders.prices.push(priceTable)
        }

        this.props.onChange(reseller, 'orders.prices')
    }

    onCopyPriceTable(event, priceTable) {
        event.stopPropagation()
        const reseller = {...this.props.reseller}

        const newPriceTable = structuredClone(priceTable)
        newPriceTable.id = Guid.generate()
        newPriceTable.name += ' (Kopie)'

        reseller.settings.orders.prices.push(newPriceTable)

        this.props.onChange(reseller, 'orders.prices')
    }

    onRemovePriceTable(event, id) {
        event.stopPropagation()
        const reseller = {...this.props.reseller}

        this.popup.open('Tarieftabel verwijderen', 'Weet je zeker dat je deze tarieftabel wilt verwijderen?', () => {
            const index = reseller.settings.orders.prices.findIndex((priceTable) => priceTable.id === id)

            if (index === -1) return

            reseller.settings.orders.prices.splice(index, 1)

            this.props.onChange(reseller, 'orders.prices')

            this.popup.close()
        })
    }

    onClickExportTables() {
        const {reseller} = this.props

        const prices = structuredClone(reseller.settings.orders.prices)
        prices.forEach((price) => {
            price.id = Guid.generate()
            price.deliveryZones = []
            price.zoneFees = {}
        })

        const blob = new Blob([JSON.stringify(prices)], {type: 'application/json'})

        const linkEl = document.createElement('a')
        linkEl.href = URL.createObjectURL(blob)
        linkEl.setAttribute('download', `${reseller.settings?.accountName || reseller.name} Tarieven`)
        linkEl.click()
    }

    onClickImportTables() {
        document.getElementById('table-import').value = null
        document.getElementById('table-import').click()
    }

    onLoadFile() {
        const {reseller, onChange} = this.props
        this.setState({fromReseller: '', error: ''})
        const file = document.getElementById('table-import').files[0]

        if (file) {
            this.setState({fileName: file.name})
            const reader = new FileReader()
            reader.readAsText(file)
            reader.onerror = (event) => {
                if (event.target.error.name == 'NotReadableError') {
                    alert('Can\'t read file !')
                }
            }
            reader.onload = (event) => {
                try {
                    const prices = JSON.parse(event.target.result)
                    if (prices.length === 0) {
                        throw new Error('Dit bestand heeft geen geldige opmaak. Er kan alleen een JSON bestand geïmporteerd worden dat ook vanuit Veloyd geëxporteerd is en dat niet is bewerkt.')
                    } else {
                        reseller.settings.orders.prices.push(...prices)
                        onChange(reseller, 'orders.prices')
                    }
                } catch {
                    this.setState({error: 'Dit bestand heeft geen geldige opmaak. Er kan alleen een JSON bestand geïmporteerd worden dat ook vanuit Veloyd geëxporteerd is en dat niet is bewerkt.'})
                }
            }
        }
    }

    addOrderProduct() {
        const orderProduct = {
            id: guid.generate(),
            name: '',
            matchAllConditions: true,
            conditionGroups: [[{
                variable: 'options',
                operator: 'contains',
                value: []
            }]]
        }

        this.productModal.open(orderProduct)
    }

    removeOrderProduct(event, orderProduct) {
        const {reseller, onChange} = this.props
        event.stopPropagation()

        this.popup.open('Product verwijderen', 'Weet je zeker dat je dit product wilt verwijderen?', () => {
            const index = reseller.settings.orders.products.findIndex((p) => p.id === orderProduct.id)

            if (index !== -1) {
                reseller.settings.orders.products.splice(index, 1)
                onChange(reseller, 'orders.products')
            }

            this.popup.close()
        })
    }

    render() {
        const {error} = this.state
        const {reseller, customers} = this.props

        return (
            <Card shadow style={{width: 600, padding: 24, height: 'fit-content'}}>
                <H3 style={{marginBottom: 36}}>Tarieven</H3>

                {error && <Alert style={{marginBottom: 6}} variant='error'>{error}</Alert>}

                <Row style={{columnGap: formSpacing.columnGap, marginBottom: 24}}>
                    <Button
                        variant='outline'
                        icon='mdi mdi-file-export'
                        label='Tarieftabellen exporteren'
                        onClick={this.onClickExportTables.bind(this)}
                    />

                    <Button
                        variant='outline'
                        icon='mdi mdi-file-import'
                        label='Tarieftabellen importeren'
                        onClick={this.onClickImportTables.bind(this)}
                    />
                </Row>

                {!!reseller.settings.orders.prices.length &&
                    <Panel style={{maxHeight: 500, overflowY: 'auto', marginBottom: 24}}>
                        {naturalSortBy(reseller.settings.orders.prices || [], 'name').map((priceTable) => {
                            return (
                                <ListItem
                                    key={`priceTable${priceTable.id}`}
                                    onClick={() => this.priceTableModal.open(priceTable)}
                                    iconButtons={[
                                        {icon: 'mdi mdi-content-copy', onClick: (event) => this.onCopyPriceTable(event, priceTable)},
                                        {icon: 'mdi mdi-delete', onClick: (event) => this.onRemovePriceTable(event, priceTable.id)}
                                    ]}
                                >
                                    {priceTable.name}

                                </ListItem>
                            )
                        })}
                    </Panel>
                }

                <Button
                    variant='outline'
                    icon='mdi mdi-plus'
                    label='Tarieftabel toevoegen'
                    onClick={() => this.priceTableModal.open()}
                />

                <H5 style={{marginBottom: 24, marginTop: 24}}>{Languages.products['NL']}</H5>

                {!!reseller.settings.orders.products?.length &&
                    <Panel style={{maxHeight: 500, marginTop: 36, flex: 1, overflowY: 'auto', marginBottom: 24}}>
                        <SortableList
                            items={reseller.settings.orders.products || []}
                            onChange={(orderProducts) => {
                                reseller.settings.orders.products = orderProducts
                                this.props.onChange(reseller, 'orders.products')
                            }}
                            renderItem={(orderProduct) => {
                                return (
                                    <ListItem
                                        key={`product${orderProduct.id}`}
                                        onClick={() => this.productModal.open(orderProduct)}
                                        icon='mdi mdi-drag-horizontal'
                                        iconButtons={[
                                            {icon: 'mdi mdi-delete', onClick: (event) => this.removeOrderProduct(event, orderProduct)}
                                        ]}
                                    >
                                        <P ellipsis>
                                            {orderProduct.name}
                                        </P>
                                    </ListItem>
                                )
                            }}
                        />
                    </Panel>
                }

                <Button
                    variant='outline'
                    icon='mdi mdi-plus'
                    label={Languages.addProduct['NL']}
                    onClick={() => this.addOrderProduct()}
                />

                <PriceTableModal
                    onSubmit={this.onUpdatePriceTable.bind(this)}
                    ref={(ref) => this.priceTableModal = ref}
                    reseller={reseller}
                    customers={customers}
                />

                <EditProductModal
                    reseller={reseller}
                    customers={customers}
                    onChange={(orderProduct) => {
                        const reseller = {...this.props.reseller}

                        const index = reseller.settings.orders.products.findIndex((p) => p.id === orderProduct.id)

                        if (typeof index === 'number' && index !== -1) {
                            reseller.settings.orders.products[index] = orderProduct
                        } else {
                            reseller.settings.orders.products.push(orderProduct)
                        }

                        this.props.onChange(reseller, 'orders.products')
                    }}
                    ref={(ref) => this.productModal = ref}
                />

                <input
                    type='file'
                    id='table-import'
                    accept='.json'
                    style={{visibility: 'hidden', height: 0}}
                    onChange={this.onLoadFile.bind(this)}
                />

                <Popup
                    ref={(ref) => this.popup = ref}
                />
            </Card>
        )
    }
}

class OrderPricesWrapper extends Reflux.Component {
    constructor(props) {
        super(props)

        this.store = CustomerStore

        this.state = {
            customers: {}
        }
    }

    render() {
        return <OrderPrices {...this.props} customers={this.state.customers} />
    }
}

export default OrderPricesWrapper
